namespace Matrix.Administration {
    export interface UserRoleListRequest extends Serenity.ServiceRequest {
        Username?: string;
    }
}
